import { useSelector } from 'react-redux';
import { selectClientEafRetroEnabled } from 'store/entities/clients/selectors/configurationSelectors';

export const useIsEafRetroEnabledForClient = () => {
    const showRetro = useSelector(selectClientEafRetroEnabled);
    return showRetro;
};
